import React, { lazy } from 'react';
import { useNavigate } from 'react-router-dom';
export const Portfolio: React.FC = () => {
  const navigate = useNavigate();
  const portfolioItems = [{
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nFzV3mNFfBGQEVaMoLmEqb/CC3A2312.jpg',
    alt: 'Outdoor wedding reception with tropical garden setting'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3j1vEXEpXxwp24FThwnumb/2Q7A6554_websize.jpg',
    alt: 'Couple holding hands in garden setting'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qirgjrEgzssm2B6MyE4x4t/CC3A2979_websize.jpg',
    alt: 'Wedding cake display in garden setting with candles and flowers'
  }];
  return <section id="portfolio" className="bg-cover bg-center relative py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8" style={{
    backgroundImage: 'url(https://uploadthingy.s3.us-west-1.amazonaws.com/v5kzhYb3Y1fNPQqndPC7id/2Q7A0955.jpg)'
  }} data-id="element-145">
      {/* Overlay for readability */}
      <div className="absolute inset-0 bg-white/85" data-id="element-146" />
      <div className="relative z-10 max-w-7xl mx-auto" data-id="element-147">
        <header className="mb-12 sm:mb-16 text-center" data-id="element-148">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-serif text-[#486878] mb-4 sm:mb-6" data-id="element-149">
            Portfolio
          </h2>
          <p className="text-[#486878] text-lg sm:text-xl max-w-2xl mx-auto" data-id="element-150">
            A glimpse into celebrations we've had the honor of creating.
          </p>
        </header>
        <div className="grid grid-cols-3 gap-4 sm:gap-6 lg:gap-8 max-w-6xl mx-auto" data-id="element-151">
          {portfolioItems.map((item, index) => <div key={index} className="relative aspect-[3/4] overflow-hidden bg-white transition-transform duration-300 group hover:scale-[1.02]" data-id="element-152">
              <img src={item.image} alt={item.alt} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" decoding="async" data-id="element-153" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-154" />
            </div>)}
        </div>

        {/* View More Button */}
        <div className="mt-12 sm:mt-16 text-center" data-id="element-155">
          <button onClick={() => navigate('/portfolio')} className="text-[#486878] underline uppercase tracking-wider text-base font-medium hover:text-[#2c5aa0] hover:no-underline transition-all inline-block min-h-[44px] px-4" data-id="element-156">
            View More
          </button>
        </div>
      </div>
    </section>;
};